import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import google from "@coveord/plasma-style/resources/icons/svg/domain-google.svg";
import salesforce from "@coveord/plasma-style/resources/icons/svg/source-salesforce.svg";
import office365 from "@coveord/plasma-style/resources/icons/svg/domain-office365.svg";
import { EmailSize32Px, SamlSize32Px } from "@coveord/plasma-react-icons";
import { svg } from "@coveord/plasma-style";
export var ProviderSvgIcon = function(param) {
    var provider = param.provider, _height = param.height, height = _height === void 0 ? 16 : _height, className = param.className;
    var commonProps = {
        height: height,
        className: className
    };
    switch(provider){
        case DomainProviders.ANY:
        case DomainProviders.EMAIL:
            return /*#__PURE__*/ _jsx(EmailSize32Px, _object_spread({
                style: {
                    color: "var(--links-color"
                }
            }, commonProps));
        case DomainProviders.GOOGLE:
            return /*#__PURE__*/ _jsx("img", _object_spread({
                src: google
            }, commonProps));
        case DomainProviders.SALESFORCE:
        case DomainProviders.SALESFORCE_SANDBOX:
            return /*#__PURE__*/ _jsx("img", _object_spread({
                src: salesforce
            }, commonProps));
        case DomainProviders.OFFICE365:
            return /*#__PURE__*/ _jsx("img", _object_spread({
                src: office365
            }, commonProps));
        case DomainProviders.SAML:
            return /*#__PURE__*/ _jsx(SamlSize32Px, _object_spread({}, commonProps));
        default:
            return null;
    }
};
export var DomainProviders = {
    ANY: "ANY",
    GOOGLE: "GOOGLE",
    SALESFORCE: "SALESFORCE",
    SALESFORCE_SANDBOX: "SALESFORCE_SANDBOX",
    OFFICE365: "OFFICE365",
    SAML: "SAML",
    EMAIL: "EMAIL"
};
var _obj;
export var ProviderSvgName = (_obj = {}, _define_property(_obj, DomainProviders.ANY, svg.email.name), _define_property(_obj, DomainProviders.GOOGLE, svg.domainGoogle.name), _define_property(_obj, DomainProviders.SALESFORCE, svg.domainSalesforce.name), _define_property(_obj, DomainProviders.SALESFORCE_SANDBOX, svg.domainSalesforce.name), _define_property(_obj, DomainProviders.OFFICE365, svg.domainOffice365.name), _define_property(_obj, DomainProviders.SAML, svg.domainSamlGradient.name), _define_property(_obj, DomainProviders.EMAIL, svg.email.name), _obj);
var _obj1;
export var DomainProviderIconModifier = (_obj1 = {}, _define_property(_obj1, DomainProviders.SALESFORCE, "salesforce-blue"), _define_property(_obj1, DomainProviders.SALESFORCE_SANDBOX, "salesforce-blue"), _define_property(_obj1, DomainProviders.OFFICE365, "office365-red"), _define_property(_obj1, DomainProviders.SAML, "documentation-link"), _define_property(_obj1, DomainProviders.ANY, "documentation-link"), _define_property(_obj1, DomainProviders.EMAIL, "documentation-link"), _obj1);

//# sourceMappingURL=GetDomainProviderIcon.js.map